import styled, { createGlobalStyle } from "styled-components";

export const ModalStyle = createGlobalStyle`
.renderbus-ui--modal {
  font-size: 14px;
  .ant-modal-content {
    padding: unset !important;
    background: transparent !important;
  }
  .ant-modal-header {
    background: var(--antd-modal-header) !important;
    padding: 0 20px;
    height: 48px;
    margin: unset !important;
    border-bottom: none;
    border-radius: 4px 4px 0 0 !important;
  }
  .ant-modal-title {
    font-size: 14px !important;
    line-height: 48px !important;
    color: #fff !important;
    vertical-align: top;
  }
  .ant-modal-body,
  .ant-modal-footer {
    border-top: none;
    margin-top: unset !important;
    background: var(--topup-recharge-input) !important;
  }
  .ant-modal-body {
    //min-height: 265px;
    padding: 20px 16px 24px;
    min-height: unset;
  }
  &.pure-text-modal {
    .ant-modal-body {
      //min-height: 105px;
    }
  }
  .ant-modal-footer {
    border-radius: 0 0 4px 4px;
    padding: 16px 24px;
    text-align: center !important;
    .ant-btn {
      border-radius: 4px;
      height: 36px;
      padding: 4px 26px;
      & + .ant-btn:not(.ant-dropdown-trigger) {
        margin-left: 16px;
      }
    }
  }
  .ant-btn.ant-btn-default {
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.25);
    border-color: transparent;
    &:hover,
    &:focus {
      color: #fff;
      border-color: transparent;
    }
  }
}
.re_modal {
  .ant-modal-header {
    background-color: #333336 !important;
  }
  .ant-modal-body {
    padding: 0px !important;
  }
}
.consume_detail_modal_diabled .ant-modal-footer {
  button:nth-child(2) {
    background: #84e4b7;
    border-radius: 4px;
    color: #ffffff;
    cursor: no-drop;
    pointer-events: none;
  }
}
.ant-modal-content {
  .ant-btn.ant-btn-primary {
    border-radius: 4px;
    background: var(--main-color);
    border-color: var(--main-color);
    &:hover {
      background: var(--main-color);
      border-color: var(--main-color);
    }
  }
}
.dingtalk-modal .ant-modal-footer{
  display: flex;
  flex-flow: row-reverse;
}
`;

export const TipWrapper = styled.div`
  background: #2c2c31;
  margin: -20px -16px 0;
  display: flex;
  align-items: flex-start;
  padding: 8px 0 8px 19px;
  color: #bfc2c3;
  font-size: 14px;
  > svg:first-child {
    margin-right: 6px;
    margin-top: 3px;
  }
`;
